enum TableConfig {
  LIMIT = 50,
  PAGE = 0,
}

export default TableConfig;
